<div class="modal-header">
	<h4 class="modal-title pull-left">Invite Users</h4>
	<button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<div class="modal-body">
	<form [formGroup]="inviteUsersForm">
		<div class="form-group">
			<label for="exampleInputEmail1">Email addresses</label>
			<textarea class="form-control" name="emails" rows="3" formControlName="email" autocomplete="off"
				placeholder="Enter comma separated email addresses" [ngClass]="{ 'is-invalid': isSubmitted && f.email.errors }"></textarea>
			<div *ngIf="isSubmitted && f.email.errors" class="invalid-feedback">
				<div *ngIf="f.email.errors.required">Emails is required</div>
				<div *ngIf="f.email.errors.minLength || f.email.errors.emailsValidator || f.email.errors.emails">Invalid emails</div>
			</div>
		</div>
	</form>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-light" (click)="cancel()">
		Cancel
	</button>
	<am-button (click)="inviteUser()" [text]="'Invite'" [isLoading]="isButtonDisabled"></am-button>
</div>